import styled from "styled-components";

import { clamp } from "@styles/utils/conversion.style";
import { colors } from "@styles/vars/colors.style";
import { mq } from "@styles/vars/media-queries.style";

export const BeastMain = styled.section`
  position: relative;
  width: 100%;
  overflow: hidden;
  background-color: ${colors.charcoal};
  color: ${colors.charcoal};

  @media (max-width: 1023px) {
    overflow: visible;
  }
`;

export const BeastWrapper = styled.div`
  position: relative;
  min-height: 100vh;
  padding-top: clamp(5rem, 7vh, 9rem);

  @media (max-width: 1023px) {
    min-height: auto;
    padding: 6rem 0;
  }
`;

export const BeastTitle = styled.h2`
  position: relative;
  z-index: 2;
  display: flex;
  justify-content: flex-end;
  align-items: baseline;
  gap: 1rem;
  margin: 0;
  color: ${colors.pastelGreen};
  font-family: Signifier;
  font-weight: 400;
  will-change: transform, opacity;

  ${clamp("font-size", 40, 72)};

  strong {
    font-family: National2;
    font-weight: 900;
  }

  @media (max-width: 1023px) {
    justify-content: flex-start;
    flex-wrap: wrap;
    margin-bottom: 5rem;
    will-change: auto;
  }
`;

export const BeastItems = styled.div`
  position: absolute;
  inset: 0;
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  align-items: end;
  padding-top: 7.5rem;

  @media (max-width: 1023px) {
    position: relative;
    inset: auto;
    align-items: flex-start;
    display: flex;
    flex-direction: column;
    padding-top: 0;
  }
`;

export const ItemTitle = styled.h3`
    ${clamp("font-size", 18, 32)};
    margin-bottom: 20px;
`;

export const BeastItem = styled.article`
  position: relative;
  min-width: 0;
  height: ${({ $index }) => `${84 - $index * 10}%`};
  display: flex;
  align-items: flex-start;
  padding: clamp(3rem, 2.8vw, 5rem)
    clamp(2rem, 2.2vw, 4rem);
  background-color: ${colors.pastelGreen};
  will-change: transform, opacity;

  ${({ $index }) =>
    $index > 0 &&
    `
      margin-left: -0.1rem;
    `}

  @media (max-width: 1023px) {
    width: 100%;
    height: auto;
    margin-left: 0;
    padding: 3.2rem 2.4rem;
    will-change: auto;
    &:nth-child(2) {
      width: calc(100% - 40px);
    }
    &:nth-child(3) {
      width: calc(100% - 80px);
    }
    &:nth-child(4) {
      width: calc(100% - 120px);
    }
  }
  
`;

export const BeastItemContent = styled.div`
  width: 100%;
  max-width: 24rem;
  color: ${colors.charcoal};

  font-weight: 400;
  line-height: 1.28;
  
  p {
    ${clamp("font-size", 16, 24)};
    font-family: National2;
    strong {
      font-family: National2;
      font-weight: 900;
    }
  }

  ${mq.tabletL} {
    max-width: 28rem;
  }

  @media (max-width: 1023px) {
    max-width: 100%;
  }
`;